import { useState } from "react";
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from "recoil";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import { userState } from "src/store/user/userState";
import { listReservationsRecentsFetchState, reservationsRecentsState } from "../state/atoms";
import ManageStorage from "src/shared/global/manageStorage";
import { parseJwt } from "src/shared/global/helpers";

const useReservationsPatient = () => {

    const [loading, setLoading] = useState(false);
    const user = useRecoilValue(userState);
    const setReservationsRecents = useSetRecoilState(reservationsRecentsState);
    const { catchErrorApi } = useCatchErrorApi()

    const tokenUser = ManageStorage.getValueFromStorage("tokenUser");
    const activeAccount = window.sessionStorage.getItem("activeAccount");

    const reservationsRecentsCallback = useRecoilCallback(({ snapshot }) => async () => {
        setLoading(true)
        try {
            const payloadToken = parseJwt(tokenUser);
            let userRut = payloadToken.Username;
    
            if (activeAccount) {
              userRut = activeAccount;
            }
            
            if (userRut) {
                const reservationsFetch = await snapshot.getPromise(listReservationsRecentsFetchState(userRut));
                //-----
                setReservationsRecents(reservationsFetch)
            }
        } catch (error) {
            catchErrorApi(error);
        } finally {
            setLoading(false)
        }
    }, []);

    return {
        reservationsRecentsCallback,
        loading
    }

};

export default useReservationsPatient;
